import type { PageLoad } from './$types';
import type { StoryCard } from '$lib/types/story';

export const load: PageLoad = async ({ fetch, url }) => {
	const labelParam = url.searchParams.get('name');
	const labels = labelParam?.split(',').map((l) => l.trim()) ?? [];

	// If no labels are provided, return empty array to avoid API error
	if (labels.length === 0) {
		return {
			label_stories: [],
			selectedLabels: []
		};
	}

	// Fetch stories from the API
	const response = await fetch(`/api/filters?labels=${labels.join(',')}`);

	if (!response.ok) {
		throw new Error('Failed to fetch stories');
	}

	const data = await response.json();

	return {
		label_stories: data.stories as StoryCard[],
		selectedLabels: labels
	};
};
